<template>
  <div class="calendarOW">
    <ul class="calendarOW__label">
      <li class="calendarOW__labelDay">dom</li>
      <li class="calendarOW__labelDay">lun</li>
      <li class="calendarOW__labelDay">Mar</li>
      <li class="calendarOW__labelDay">mie</li>
      <li class="calendarOW__labelDay">jue</li>
      <li class="calendarOW__labelDay">vie</li>
      <li class="calendarOW__labelDay">sab</li>
    </ul>
    <div class="calendarOW__week">
      <div class="calendarOW__weekDates">
        <span class="calendarOW__weekDay">1</span>
        <div class="calendarOW__price">
          <span class="calendarOW__value">1.120.232,52</span>
          <span class="calendarOW__currency">COP</span>
        </div>
      </div>
      <div class="calendarOW__weekDates">
        <span class="calendarOW__weekDay">1</span>
        <div class="calendarOW__price">
          <span class="calendarOW__value">120.232,52</span>
          <span class="calendarOW__currency">COP</span>
        </div>
      </div>
      <div class="calendarOW__weekDates">
        <span class="calendarOW__weekDay">1</span>
        <div class="calendarOW__price">
          <span class="calendarOW__value">20.232,52</span>
          <span class="calendarOW__currency">COP</span>
        </div>
      </div>
      <div class="calendarOW__weekDates">
        <span class="calendarOW__weekDay">1</span>
        <div class="calendarOW__price">
          <span class="calendarOW__value">1.120.232,52</span>
          <span class="calendarOW__currency">COP</span>
        </div>
      </div>
      <div class="calendarOW__weekDates">
        <span class="calendarOW__weekDay">1</span>
        <div class="calendarOW__price">
          <span class="calendarOW__value">1.120.232,52</span>
          <span class="calendarOW__currency">COP</span>
        </div>
      </div>
      <div class="calendarOW__weekDates">
        <span class="calendarOW__weekDay">1</span>
        <div class="calendarOW__price">
          <span class="calendarOW__value">1.120.232,52</span>
          <span class="calendarOW__currency">COP</span>
        </div>
      </div>
      <div class="calendarOW__weekDates">
        <span class="calendarOW__weekDay">1</span>
        <div class="calendarOW__price">
          <span class="calendarOW__value">1.120.232,52</span>
          <span class="calendarOW__currency">COP</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'calendarOW'
}
</script>

<style lang="sass">
.calendarOW
  display: flex
  flex-direction: column
  width: 100%
  &__label
    background: var(--color-overlay-05)
    text-transform: uppercase
    list-style: none
    font-size: var(--font-size-sm)
    font-weight: bolder
    display: flex
    justify-content: space-between
    align-items: center
    margin: 0
    padding: 0
    &Day
      border: 1px solid var(--color-overlay-05)
      flex-basis: 100%
      text-align: center
      padding: 1rem
  &__week
    display: flex
  &__weekDates
    border: 1px solid var(--color-overlay-05)
    flex-basis: 100%
    display: flex
    flex-direction: column
    padding: 1rem .5rem
    flex: 1
    flex-wrap: wrap
    cursor: pointer
    transition: 0.2s ease
    &:hover
     box-shadow: var(--z-1), inset 0 0 0 10rem var(--color-overlay-05)
  &__weekDay
    text-align: right
  &__price
    display: flex
    flex-wrap: wrap
    justify-content: flex-end
    align-items: flex-end
    padding: 1rem 0 1rem 0
  &__value
    font-size: var(--font-size-md)
    font-weight: bolder
    line-height: 1.2em
  &__currency
    font-size: var(--font-size-xs)
</style>
